module.exports = __webpack_public_path__ + "img/zhibiaochaxun.122f0c57.svg";